/**
 * ============================================================================
 * EXPERIMENT: Travel Rhythm Display (ab_travel_rhythm)
 *
 * Backend-driven AB test — variant decided server-side via API
 * `meta.experiment.travelRhythm`. No Amplitude experiment, no entry in
 * `feature-flags.json`: the variant is implicit — the feature renders only
 * when the API returns a rhythm value.
 *
 * PR: #TODO_AFTER_PR_CREATION_ab_travel_rhythm
 * Expected end date: 2026-07-22 (remove all AB_* files and BEGIN/END markers by then).
 *
 * Temporary code — will be REMOVED when the experiment concludes.
 * Find all experiment code: grep -rn "ab_travel_rhythm" src/
 * ============================================================================
 */
export function getTravelRhythmDismissKey(dossierId: string): string {
    return `rm.travelRhythmModalSeen.${dossierId}`;
}

export function isTravelRhythmModalDismissed(dossierId: string, storage: Storage): boolean {
    return storage.getItem(getTravelRhythmDismissKey(dossierId)) === '1';
}

export function markTravelRhythmModalDismissed(dossierId: string, storage: Storage): void {
    storage.setItem(getTravelRhythmDismissKey(dossierId), '1');
}
